export { Label } from "@repo/ui";
